import { Position, Toaster } from '@blueprintjs/core';

export const AppToaster = Toaster.create({
    className: 'AppToaster',
    position: Position.TOP
});
